import React, { useState, useEffect } from 'react';
import archive from 'common/assets/svg/actions/archive.svg';
import SvgRender from 'common/components/general/SvgRender';
import useRouter from 'use-react-router';

import { parseQueryParams } from 'common/utils/urls';

const ArchivedButton = ({ className, label, topFilters, setTopFilters }) => {
  const { location } = useRouter();
  const [isArchive, setIsArchive] = useState(false);

  const onSeeArchived = () => {
    const archivedFilter = { name: 'archived', operation: '=', value: 'true' };
    const newFilters = [archivedFilter, ...topFilters];

    setTopFilters(newFilters);
  };

  const onGoBack = () => {
    const isArchived = topFilters?.find(f => f.name === 'archived');

    const newFilters = isArchived
      ? topFilters.map(f => (f.name === 'archived' ? { ...f, value: null } : f))
      : [...topFilters, { name: 'archived', operation: '=', value: null }];

    setTopFilters(newFilters);
  };

  useEffect(() => {
    if (location.search) {
      const params = parseQueryParams(location.search);

      if (
        params.filters &&
        params.filters.length > 0 &&
        params.filters.find(el => el.name === 'archived')
      ) {
        setIsArchive(true);
      } else {
        setIsArchive(false);
      }
    } else {
      setIsArchive(false);
    }
  }, [location.search]);

  return (
    <div className={`d-flex align-items-center ${className ? className : ''}`}>
      {isArchive ? (
        <div className="fs-10 d-flex align-items-center">
          <div
            onClick={onGoBack}
            className="d-inline-flex align-items-center cursor-pointer back-to-list"
            dataCy="back-to-list"
          >
            Back to List
          </div>
          <div className="text-primary">Archived</div>
        </div>
      ) : (
        <div
          onClick={onSeeArchived}
          className="d-inline-flex align-items-center text-primary cursor-pointer "
          data-cy="see_archived"
        >
          <SvgRender src={archive} style={{ width: 14, height: 14 }} className="me-1" />
          <span className="lh-1 fs-10 fw-normal">See archived {label}</span>
        </div>
      )}
    </div>
  );
};

export default ArchivedButton;
